<div class="card" [loadingOverlay]="isLoading" *withPermissions="let allow of ['CanManagePartnerEmails']">
  <div class="card-header">
    {{partnerMinimal.PartnerName}} Emails
    <button (click)="close()" class="btn-close" title="Close"></button>
  </div>
  <div class="card-body">
    <app-tab-panel [displayMode]="tabPanelDisplayMode.horizontal">
      <app-tab [title]="'Settings'">
        <ng-container *tabContent>
          <app-components-manager-partner-notification-settings
            [partner]="partner"
            [options]="options"
            *ngIf="partner"
            >
          </app-components-manager-partner-notification-settings>
        </ng-container>
      </app-tab>
      <app-tab [title]="'Emails'">
        <ng-container *tabContent>
          <app-table [items]="notificationDefinitions">
            <ng-template #tableHeader>
              <tr>
                <th class="col-10" sort asc field="Name">Type</th>
                <th class="col-1">Templates</th>
                <th class="col-1" sort field="EnabledForSubscriber">Enabled</th>
              </tr>
            </ng-template>
            <ng-template #tableBody let-item>
              <ng-container>
                <tr>
                  <td><app-components-helptext [key]="'Notification_' + item.Name"></app-components-helptext>{{item.Name}}</td>
                  <td>
                    <button class="btn btn-info" (click)="openTemplates(item)">
                      <span><i class="fa fa-magnifying-glass"></i> View</span>
                    </button>
                  </td>
                  <td>
                    <shared-components-customchoice type="checkbox" [(ngModel)]="item.EnabledForSubscriber"
                      [disabled]="!allow().CanManagePartnerEmails() || !item.Disableable"></shared-components-customchoice>
                  </td>
                </tr>
              </ng-container>
            </ng-template>
          </app-table>
        </ng-container>
      </app-tab>
    </app-tab-panel>
  </div>
  <div class="card-footer" *ngIf="allow().CanManagePartnerEmails()">
    <button class="btn btn-success float-end" (click)="save()">Save Changes</button>
  </div>
</div>
